import React from 'react';
import { useSelector } from 'react-redux';
import { selectDynamicCardIsOngoingLinking } from 'core/modules/Instore2/selectors';
import Loader from 'core/modules/Partials/Loader/Loader';
import InstoreOfferButtons from './InstoreOfferButtons';

function InstoreOfferLink({ instoreOffer, isInstoreLoaded, clearFeedback }) {
  const { offerId } = instoreOffer;
  const isOngoingLinking = useSelector(state => selectDynamicCardIsOngoingLinking(state, offerId));

  return (
    <Loader isLoading={!isInstoreLoaded || isOngoingLinking}>
      <InstoreOfferButtons instoreOffer={instoreOffer} onClickCallback={clearFeedback} />
    </Loader>
  );
}

export default InstoreOfferLink;
